import { initialAccountManagementState } from 'redux/initialState';

import accountManagementActionTypes from './action-types';

const accountManagementReducer = (state = initialAccountManagementState, { type, payload }) => {
  switch (type) {
    case accountManagementActionTypes.SET_TEST_ACCOUNT_MANAGEMENT:
      return {
        ...state,
        context: payload,
      };

    default:
      return state;
  }
};

export default accountManagementReducer;
